var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E8E8E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1230_84406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9189 26.32C30.6599 26.571 30.5409 26.934 30.5999 27.29L31.4889 32.21C31.5639 32.627 31.3879 33.049 31.0389 33.29C30.6969 33.54 30.2419 33.57 29.8689 33.37L25.4399 31.06C25.2859 30.978 25.1149 30.934 24.9399 30.929H24.6689C24.5749 30.943 24.4829 30.973 24.3989 31.019L19.9689 33.34C19.7499 33.45 19.5019 33.489 19.2589 33.45C18.6669 33.338 18.2719 32.774 18.3689 32.179L19.2589 27.259C19.3179 26.9 19.1989 26.535 18.9399 26.28L15.3289 22.78C15.0269 22.487 14.9219 22.047 15.0599 21.65C15.1939 21.254 15.5359 20.965 15.9489 20.9L20.9189 20.179C21.2969 20.14 21.6289 19.91 21.7989 19.57L23.9889 15.08C24.0409 14.98 24.1079 14.888 24.1889 14.81L24.2789 14.74C24.3259 14.688 24.3799 14.645 24.4399 14.61L24.5489 14.57L24.7189 14.5H25.1399C25.5159 14.539 25.8469 14.764 26.0199 15.1L28.2389 19.57C28.3989 19.897 28.7099 20.124 29.0689 20.179L34.0389 20.9C34.4589 20.96 34.8099 21.25 34.9489 21.65C35.0799 22.051 34.9669 22.491 34.6589 22.78L30.9189 26.32Z",
    fill: "#32324B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1230_84406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/start_icon.8c68b238dbc97ed6d852bfb39c5f1e9a.svg";
export { ForwardRef as ReactComponent };